import { createApi } from "@reduxjs/toolkit/query/react";
import { authBaseQuery } from "../../services/baseQuery";
import {
  getRefreshToken,
  getTenantId,
  getTenantIdForPayload,
} from "../../services/authSession";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({ email, password }) => ({
        url: "cas/api/authenticate",
        method: "POST",
        body: {
          email,
          password,
          tenant_id: getTenantIdForPayload(),
        },
      }),
    }),
    refreshSession: builder.mutation({
      query: (refreshToken = getRefreshToken()) => {
        const params = new URLSearchParams({ tenant_id: getTenantId() });

        return {
          url: `cas/refresh-token?${params.toString()}`,
          method: "POST",
          body: { refreshToken },
        };
      },
    }),
  }),
});

export const { useLoginMutation, useRefreshSessionMutation } = authApi;

